// extracted by mini-css-extract-plugin
module.exports = {"card":"KpiCard_card__38Tdl","caption":"KpiCard_caption__xXw3t"};